import React, { useState, useEffect } from 'react';

import { isEmpty } from '../Util';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const BuyerSearchResult = ({ result, onClose }) => {
    const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handleEscKey);
        document.body.style.overflow = 'hidden';
        return () =>{ 
            document.removeEventListener('keydown', handleEscKey);
            document.body.style.overflow = 'auto'; 
        }
    }, [onClose]);

    const handleSelectCompany = (company) => {
        setSelectedCompany(company);
    }

    const handleConfirmCompany = () => {
        navigate("/Quotation", { state: { shouldPatchTransaction: true, buyer: selectedCompany} })
    };

    const { t } = useTranslation();
    const navigate = useNavigate();
    
    return (
        <div className="popin-overlay">
            <div className="popin-container">
                <div className="popin-header d-flex justify-content-between align-items-center mt-3">
                    
                    {!isEmpty(result) ?

                        <div className="az-pay-title p-4">
                            {t("BuyerSearchResult.title")}
                        </div>
                        :
                        <div className="az-pay-title p-4">
                        {t("BuyerSearchResult.noResult.title")}
                    </div>

                    }
                    
                        
                    <button className="close-button p-4" onClick={onClose} >
                        &times;
                    </button>
                </div>

                {isEmpty(result) ?
                    <div className="p-4">
                        
                        <div className="middle-font az-pay-subtitle">
                            {t("BuyerSearchResult.noResult.text")}
                        </div>
                    </div>
                    :
                    <div className="p-4 popin-content">
                        <h3 className="mb-3 az-pay-subtitle">
                            {t("BuyerSearchResult.select.text")}
                        </h3>

                        <div className="company-list-container mt-3">
                            {result.map((company, index) => (
                                <div key={index}
                                    className={`border-2 rounded-4 p-3 mb-2 cursor-pointer company-card ${selectedCompany === company ? "selected" : ""}`}
                                    onClick={() => handleSelectCompany(company)}>
                                    <div className="fw-bold"><span className='me-2'><img src={selectedCompany ? process.env.PUBLIC_URL + 'images/company-icon-selected.svg':process.env.PUBLIC_URL + 'images/company-icon.svg'}></img></span>{company.name}</div>
                                    <div>{company.address?.streetNumber} {company.address?.streetName}</div>
                                    <div>{company.address?.postCode} {company.address?.city}</div>
                                    <div>{company.address?.Country} </div>
                                    <div>{company.mainIdentifierTypeCode} - {company.mainIdentifierValue}</div>
                                </div>
                            ))}
                        </div>

                        <div className="d-flex justify-content-start">
                            <button type="submit"
                                className="az-btn mt-4 "
                                onClick={handleConfirmCompany}
                                disabled={!selectedCompany}>
                                {t("BuyerSearchResult.confirm.btn")}
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default BuyerSearchResult;